import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';

import type { VerbForms } from '@/api/types';

import { PRONOUNS } from '../verbs';

interface VerbCellProps {
    forms: VerbForms;
    titles: readonly string[];
}

const VerbCell = ({ forms, titles }: VerbCellProps) => (
    <TableCell>
        {titles.map((title) => (
            <Typography key={title} color="textSecondary">{title}</Typography>
        ))}
        <List>
            {PRONOUNS.map(([pronoun, label]) => (
                <ListItem key={pronoun}>
                    <Typography color="textSecondary">{label}&nbsp;</Typography>
                    <Typography>{forms[pronoun]}</Typography>
                </ListItem>
            ))}
        </List>
    </TableCell>
);

export default VerbCell;
